import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import StoryForm from '@/components/stories/StoryForm.vue';
import CurrentLanguage from '@/components/CurrentLanguage.vue';
import { Story } from '@/models/story.model';
import { useEvents, Event } from '@/services/events.composable';
import { Mutations, ShiftCMSState } from '@/store';
import {
  StoriesActions,
  StoriesMutations,
  StoriesState,
} from '@/stores/stories.store';
import { computed, markRaw, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import TranslatedState from '@/components/common/TranslatedState.vue';
import { capitalize } from '@/util/string.util';
import ListFilter from '@/components/common/ListFilter.vue';
import { CategoriesActions } from '@/stores/categories.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'StoriesList',
  setup(__props) {

const store = useStore<ShiftCMSState & { ts: StoriesState }>();
const router = useRouter();
const events = useEvents();
const stories = computed<Story[]>(() => store.state.ts.stories);

const addStory = () => {
  store.commit(Mutations.ShowDrawer, { component: markRaw(StoryForm) });
};

const showStory = (_: Event, { item }: { item: Story }) => {
  store.dispatch(StoriesActions.GetStory, item.id);

  router.push(`/stories/${item.id}`);
};

const update = () => {
  store.dispatch(StoriesActions.GetStories);
  store.dispatch(CategoriesActions.GetCategories);
};

onMounted(() => {
  events.on(Event.LanguageChanged, update);
  store.commit(StoriesMutations.SetStory, null);
  update();
});

onBeforeUnmount(() => {
  events.off(Event.LanguageChanged, update);
  store.commit(Mutations.HideDrawer);
});

const headers = [
  { title: 'ID', key: 'id', width: '5%', sortable: true },
  { title: 'Title', key: 'title', width: '40%' },
  { title: 'Type', key: 'type', width: '5%' },
  { title: 'Category', key: 'mainCategory', width: '15%' },
  { title: 'Pages', key: 'items', width: '10%' },
  { title: 'State', key: 'translated', width: '25%', sortable: false },
];

const filter = ref<string>('');
const filterTitle = ref<string>('');
const filteredStories = computed(() =>
  stories.value
    .filter((v) => (filter.value ? v.type === filter.value : true))
    .filter((v) =>
      filterTitle.value
        ? v.title.toLowerCase().indexOf(filterTitle.value.toLowerCase()) !== -1
        : true,
    ),
);

function updateFilter(filters: { filter: string; filterTitle: string }) {
  filter.value = filters.filter;
  filterTitle.value = filters.filterTitle;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("h2", null, [
        _cache[0] || (_cache[0] = _createTextVNode("Stories ")),
        _createVNode(CurrentLanguage)
      ]),
      _createVNode(ListFilter, {
        options: [
        { label: 'Quiz', value: 'quiz' },
        { label: 'Story', value: 'story' },
      ],
        onFilter: updateFilter
      }),
      _createVNode(_component_v_data_table, {
        density: "compact",
        "onClick:row": showStory,
        headers: headers,
        items: filteredStories.value.sort((a, b) => a.index - b.index),
        itemsPerPage: "25",
        hover: ""
      }, {
        "item.items": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value.length) + " pages ", 1)
        ]),
        "item.type": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(_unref(capitalize)(value)), 1)
        ]),
        "item.mainCategory": _withCtx(({ value }) => [
          _createTextVNode(_toDisplayString(value?.title || 'Unknown'), 1)
        ]),
        "item.translated": _withCtx(({ item }) => [
          _createVNode(TranslatedState, { item: item }, null, 8, ["item"]),
          _cache[1] || (_cache[1] = _createTextVNode("   ")),
          _createVNode(_component_v_tooltip, {
            text: 
            item.published
              ? 'This story is published'
              : 'This story is not published'
          
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_icon, _mergeProps(props, {
                icon: item.published ? 'mdi-eye-check' : 'mdi-eye-outline',
                color: item.published ? 'green' : 'red'
              }), null, 16, ["icon", "color"])
            ]),
            _: 2
          }, 1032, ["text"])
        ]),
        _: 1
      }, 8, ["items"]),
      _createVNode(_component_v_btn, {
        onClick: addStory,
        color: "success"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Add Story")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})